import HtmlNode from '../Extension/HtmlNode';
import { MarketCode } from '../../@types/MarketCode';
import { getWordmarkLogotype } from '../../Templates/Logotype';

interface ModalHeaderProps {
  readonly title: string;
  readonly id: string;
  readonly logo?: string;
  readonly logo2x?: string;
  readonly market?: MarketCode;
  readonly onClose?: () => void;
}

class ModalHeader extends HtmlNode {
  private readonly props: ModalHeaderProps;

  constructor(element: HTMLElement, props: ModalHeaderProps) {
    super(element, {
      htmlTag: 'header',
      className: 'waykevaluation-modal__header',
      id: props.id,
    });
    this.props = props;
    this.render();
  }

  render() {
    const { title, logo, logo2x, market, onClose } = this.props;
    this.node.innerHTML = `
      <div class="waykevaluation-header">
        <div class="waykevaluation-header__logo">
          <h2 class="waykevaluation-no-margin">
            ${
              logo
                ? `
                  <img
                    src="${logo}"
                    ${logo2x ? `srcset="${logo2x} 2x"` : ''}
                    alt="${title}"
                    class="waykevaluation-image"
                  />
                `
                : `
                  <span class="waykevaluation-sr-only" id="wayke-valuation-title">${title}</span>
                  ${getWordmarkLogotype({
                    market,
                    className: 'waykevaluation-header__logo--svg',
                  })}
                `
            }
          </h2>
        </div>
      </div>
    `;
    if (onClose) {
      this.node.querySelectorAll<HTMLButtonElement>('button').forEach((button) => {
        button.addEventListener('click', () => onClose());
      });
    }
  }
}

export default ModalHeader;
